import { createSlice } from "@reduxjs/toolkit"

const initialState = {
	provinsi: [
		"Nanggroe Aceh Darussalam",
		"Sumatera Utara",
		"Sumatera Selatan",
		"Sumatera Barat",
		"Bengkulu",
		"Riau",
		"Kepulauan Riau",
		"Jambi",
		"Lampung",
		"Bangka Belitung",
		"Kalimantan Barat",
		"Kalimantan Timur",
		"Kalimantan Selatan",
		"Kalimantan Tengah",
		"Kalimantan Utara",
		"Banten",
		"DKI Jakarta",
		"Jawa Barat",
		"Jawa Tengah",
		"Daerah Istimewa Yogyakarta",
		"Jawa Timur",
		"Bali",
		"Nusa Tenggara Timur",
		"Nusa Tenggara Barat",
		"Gorontalo",
		"Sulawesi Barat",
		"Sulawesi Tengah",
		"Sulawesi Utara",
		"Sulawesi Tenggara",
		"Sulawesi Selatan",
		"Maluku Utara",
		"Maluku",
		"Papua Barat",
		"Papua",
		"Papua Tengah",
		"Papua Pegunungan",
		"Papua Selatan",
		"Papua Barat Daya"
	]
}

export const slice = createSlice({
	name: "alamat",
	initialState,
})

export const alamatReducer = slice.reducer